import { lazy } from "react"

export const DriversPage = lazy(() => import("./DriversPage"))